import { render } from "./AssessoreList.vue?vue&type=template&id=445636c1&ts=true"
import script from "./AssessoreList.vue?vue&type=script&lang=ts"
export * from "./AssessoreList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__